import React from "react";
import styled from "styled-components";

// Styled Components

const Container = styled.div`
  width: 75%;
  padding: 2rem;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 2rem;
`;

const Column = styled.div`
  flex: 1;
  padding: 1rem;
`;

const Image = styled.img`
  width: 30%;

  @media (max-width: 1000px) {
    width: 75%;
  }

  @media (max-width: 768px) {
    width: 75%;
  }
`;

const TextSection = styled.div`
  width: 100%;
  margin-top: 2rem;

  p {
    color: black;
    font-size: 1rem;
    line-height: 1.6;

    b {
      font-weight: bold;
    }

    i {
      font-style: italic;
    }
  }

  hr {
    margin: 2rem 0;
  }
`;

const OctoberSalon: React.FC = () => {
  return (
    <Container>
      <Row>
        <Image
          src="/images/oktobarski_salon.jpg"
          alt="citajte o - oktobarski salon"
        />
      </Row>
      <TextSection>
        <p>
          <b>Oktobarski salon</b> је изложба репрезентативних дела из сфере
          актуелног стваралаштва у области визуелних уметности, која има статус
          сталне манифестације у области културе од значаја за Град Београд.
          <br />
          Савет Модерне галерије (која је с временом прерасла у Музеј савремене
          уметности у Београду) на основу свог статута и акта Секретаријата за
          просвету и културу Народног одбора града Београда на седници одржаној
          19. маја 1960. године донео је решење о оснивању Октобарског салона.
          <br />
          Први Октобарски салон одржан је у Уметничком павиљону у Масариковој
          улици, привремено изграђеном објекту који је функционисао до 1974.
          године. Од тада Октобарски салона мења просторе у којима се одржава.
          <br />
          <br />
          <b>
            Задатак Октобарског салона био је да сваке године о годишњици
            ослобођења Београда приређује изложбу репрезентативних остварења
            савремене српске ликовне уметности.
          </b>
          <br />
          <br />
          Он ће обогатити културни живот Београда и пружити могућност нашој
          јавности да се упозна са најбољим остварењима наше ликовне уметности и
          тако стекне јаснију и прегледнију слику о њеним кретањима и
          вредностима. Октобарски салон ће допринети уметничком васпитању наших
          људи и умногоме стимулирати стварање самих уметника. Показујући вредна
          остварења наших ликовних уметника, без обзира којим генерацијама и
          школама припадају, Октобарски салон ће омогућити и упоређења,
          садржајније анализе и одређеније закључке. Сигурно је да ће Салон
          имати видан утицај на развијање нашег ликовног живота и на поједина
          уметничка стремљења, што ће свакако бити корисно за даљи развој наше
          ликовне уметности. Из тих разлога Народни одбор града Београда помоћи
          ће да Октобарски салон испуни своје друштвене, културне и уметничке
          задатке ради којих је и основан. То ће бити могуће остварити уз
          потпуно ангажовање свих ликовних уметника Србије и осталих културних
          радника као и уз подршку широке културне јавности. (Из текста Ђурице
          Јојкића, председника Народног одбора града Београда у каталогу 1.
          Октобарског салона, 1960.)
          <br />
          <br />
          Године 1967. Салон се претвара у смотру актуелних уметничких токова
          којој се прикључују и остварења из примењених уметности.
          <br />
          Године 2004. на иницијативу дугогодишњег организатора, Културног
          центра Београда, а одлуком оснивaча, Града Београда, добија
          међународни карактер.
          <br />
          Године 2014, одлуком оснивача постаје бијенална манифестација.
          <br />
          Октобарски салон има Одбор и уметничког директора/директорку, које
          именује Скупштина Града Београда.
          <br />
          Организационе, стручне, административне, финансијске и техничке
          послове за потребе Октобарског салона обавља правно лице, коме
          обављање тих послова уговором повери Град Београд.
          <br />
          Двојезична издања каталога Октобарских салона постоје од 2004. године.
          <br />
          <em>
            Сарадња са Одељењем за уметничку документацију, у оквиру које су
            постављена дигитализована издања каталога Октобарских салона у
            периоду од 1960. до 2021. године иницирана је и спроведена као део
            програма 59. Октобарског салона, чији је организатор и аутор
            концепције Културни центар Београда.
          </em>
          <br />
          <br />
          <hr />
          <br />
          <b>October Salon</b> is an exhibition of representative works from the
          sphere of current visual arts’ production, having the status of a
          regular cultural event of significance for the City of Belgrade.
          <br />
          At its session held on 19 May 1960, the Council of the Modern Gallery
          (which in time transformed into the Museum of Contemporary Art), based
          on its Statute and an act of the Culture and Education Secretariat of
          the People’s Board of the City Of Belgrade, adopted the decision on
          the establishment of the October Salon.
          <br />
          The 1st October Salon was held in the Art Pavilion in Masaryk’s
          Street, a temporary building which was used by 1974. Ever since, the
          October Salon has been changing venues for its exhibitions.
          <br />
          <br />
          <b>
            The role of the October Salon was to organise every year, upon the
            anniversary of the liberation of Belgrade in WWII, an exhibition of
            representative works in contemporary Serbian visual arts.
          </b>
          <br />
          <br />
          “It will enrich the cultural life of Belgrade and provide our public
          with an opportunity to become acquainted with the best achievements of
          our visual arts, and thus get a better insight into their evolution
          and values. The October Salon will contribute to the artistic
          education of our people and largely stimulate some among them to
          become artists. By exhibiting valuable works by our visual artists,
          regardless of a generation or school to which they belong, the October
          Salon will also enable comparison, more comprehensive analyses and
          more valid conclusions. It is certain that the Salon will have an
          apparent impact on the development of our visual culture and life, as
          well as on certain artistic movements, which would in turn certainly
          be beneficial for the further development of our visual arts.
          Therefore, the People’s Board of the City of Belgrade will help the
          October Salon fulfil the social, cultural and artistic tasks for which
          it is established. The achievement of this will be made possible with
          the full engagement of all visual artists and other cultural workers
          in Serbia, as well as with the support of the wide cultural public.”
          (Taken out of the text by Đurica Jojkić, Chairman of the People’s
          Board of the City of Belgrade, contained in the catalogue of the 1st
          October Salon, 1960)
          <br />
          <br />
          In 1967, the Salon transformed into a survey exhibition of current
          artistic tendencies, and was included works of applied arts.
          <br />
          In 2004, upon an initiative by the Cultural Centre of Belgrade which
          had been organising the Salon for a number of years and by the
          decision of its founder, the City of Belgrade, the October Salon
          became international in character.
          <br />
          In 2014, by the decision of its founder, the October Salon became a
          biennial event.
          <br />
          The October Salon has its Board and Art Director, appointed by the
          Assembly of the City of Belgrade.
          <br />
          Organisational, professional, administrative, financial and technical
          tasks for the benefit of the October Salon are performed by the legal
          entity to which performance of these tasks is contractually delegated
          by the City of Belgrade.
          <br />
          Bilingual editions of the October Salon’s catalogues have been made
          since 2004.
          <br />
          <br />
          <em>
            The cooperation with the Department of Artistic Documentation, which
            has involved the uploading of the digitized October Salon catalogues
            from 1960 to 2021, was initiated and executed as a part of the
            programme of the 59th October, organised by the Cultural Centre of
            Belgrade and its concept authored by the collective of the Cultural
            Centre of Belgrade.
          </em>
        </p>
      </TextSection>
    </Container>
  );
};

export default OctoberSalon;
